import { log } from '@shared/log.browser.ts';
import { isSponsoredProduct } from '@shared/types/types';
import type { EventsOutgoing } from '@tilelist/application/ports/EventsOutgoing.ts';
import { isProductItem } from '@tilelist/domain/composition/TileListitem.ts';
import type { TileListItem } from '@tilelist/domain/composition/TileListitem.ts';

const MAX_ITEMS_TO_TRACK = 5;

export function trackFirebase(eventsOutgoing: EventsOutgoing, tileListItems: TileListItem[]) {
    const productItemsToTrack = tileListItems
        .filter(isProductItem)
        .filter(({ product }) => !isSponsoredProduct(product))
        .slice(0, MAX_ITEMS_TO_TRACK);

    const itemIds = productItemsToTrack.map(({ product }) => product.articleNumber ?? 'UNKNOWN');

    for (const [index, productItem] of productItemsToTrack.entries()) {
        const item_id = itemIds[index];

        log.debug(
            `Firebase Tracking: item_id:${item_id}, localListPosition: ${productItem.localListPosition}, productType: ${productItem.product.productType}`,
        );
    }

    if (itemIds.length > 0) {
        eventsOutgoing.trackProductView(itemIds);
    }
}
